import React, { useRef, useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const ZoomableImage = () => {
  const transformRef = useRef(null); // Create a reference for TransformWrapper
  const [isOpen, setIsOpen] = useState(false);
  const [image, setImage] = useState(false);

  return (
    <div>
      {/* Click to open the popup */}
      <img
        src="https://visa-prod.imgix.net/visa/d8a81972-3c50-41d2-9126-02ddcffabb49/Basic_DP_Case-1_image_1738597021812.jpg?auto=compress,format&width=200"
        alt="Click to enlarge"
        style={{ cursor: "pointer", width: "150px" }}
        onClick={(e) => {setIsOpen(true); setImage("https://visa-prod.imgix.net/visa/d8a81972-3c50-41d2-9126-02ddcffabb49/Basic_DP_Case-1_image_1738597021812.jpg?auto=compress,format")}}
      />

<img
        src="https://visa-prod.imgix.net/visa/d8a81972-3c50-41d2-9126-02ddcffabb49/Basic_DP_Case-2_image_1738597600983.jpg?auto=compress,format&width=200"
        alt="Click to enlarge"
        style={{ cursor: "pointer", width: "150px" }}
        onClick={(e) => {setIsOpen(true); setImage("https://visa-prod.imgix.net/visa/d8a81972-3c50-41d2-9126-02ddcffabb49/Basic_DP_Case-2_image_1738597600983.jpg?auto=compress,format")}}
      />

<img
        src="https://visa-prod.imgix.net/visa/d8a81972-3c50-41d2-9126-02ddcffabb49/Basic_DP_Case-4_image_1738598050029.jpg?auto=compress,format&width=200"
        alt="Click to enlarge"
        style={{ cursor: "pointer", width: "150px" }}
        onClick={(e) => {setIsOpen(true); setImage("https://visa-prod.imgix.net/visa/d8a81972-3c50-41d2-9126-02ddcffabb49/Basic_DP_Case-4_image_1738598050029.jpg?auto=compress,format")}}
      />

      {/* Zoom Modal */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
          onClick={() => setIsOpen(false)}
        >
          <div
            style={{
              position: "relative",
              background: "white",
              padding: "10px",
              borderRadius: "10px",
              maxWidth: "90vw",
              maxHeight: "90vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "red",
                color: "white",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              onClick={() => setIsOpen(false)}
            >
              Close
            </button>

            {/* Zoomable Image */}
            <TransformWrapper ref={transformRef} initialScale={1}>
              <div style={{ textAlign: "center", marginBottom: "10px" }}>
                <button onClick={() => transformRef.current.zoomIn()} style={buttonStyle}>➕</button>
                <button onClick={() => transformRef.current.zoomOut()} style={buttonStyle}>➖</button>
                <button onClick={() => transformRef.current.resetTransform()} style={buttonStyle}>🔄 Reset</button>
              </div>
              <TransformComponent>
                <img
                  src={image}
                  alt="Zoomable Image"
                  style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "10px" }}
                />
              </TransformComponent>
            </TransformWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

// Button styles
const buttonStyle = {
  margin: "5px",
  padding: "8px 12px",
  fontSize: "16px",
  cursor: "pointer",
  borderRadius: "5px",
  border: "none",
  background: "#333",
  color: "white",
};

export default ZoomableImage;
